export const FILE_TYPES = {
  IMAGE: ['png', 'jpg', 'jpeg', 'svg'],
  AUDIO: ['mp3', 'ogg', 'mpeg'],
  VIDEO: ['mp4'],
  PDF: ['pdf'],
  SPREADSHEET: ['csv', 'xlsx']
}